const appName = state => 'CGIP ' + state.appName

const loggedIn = state => state.loggedIn

const websiteConfig = state => state.websiteConfig

const programImages = state => state.websiteConfig.program_images

const platformImages = state => state.websiteConfig.platform_images

const platformPointCap = state => state.platformPointCap

const dashboardLayout = state => state.dashboardLayout

const participant = state => state.participant

const programs = state => state.programs

const programDetails = state => state.programDetails

const programDashboard = state => state.programDashboard

const pageDetails = state => state.pageDetails

const points = state => state.points

const rewardFilters = state => state.rewardFilters

const categories = state => state.categories

const categoryDetails = state => state.categoryDetails

const cards = state => state.cards

const rewards = state => state.rewards

const rewardDetails = state => state.rewardDetails

const participantSetup = state => state.participantSetup

const approverClaims = state => state.approverClaims

const submitterClaims = state => state.submitterClaims

const reportData = state => state.reportData

const claimModalData = state => state.claimModalData

const claimModalShow = state => state.claimModalShow

const claimModalType = state => state.claimModalType

const claimModalMessage = state => state.claimModalMessage

const savedRewards = state => state.savedRewards

const leaderboardModalData = state => state.leaderboardModalData

const leaderboardModalShow = state => state.leaderboardModalShow

const chartData = state => state.chartData

export {
  appName,
  loggedIn,
  websiteConfig,
  dashboardLayout,
  participant,
  programs,
  programDetails,
  programDashboard,
  pageDetails,
  points,
  rewardFilters,
  cards,
  categories,
  categoryDetails,
  rewards,
  rewardDetails,
  participantSetup,
  approverClaims,
  submitterClaims,
  reportData,
  claimModalData,
  claimModalShow,
  claimModalType,
  claimModalMessage,
  platformImages,
  programImages,
  savedRewards,
  leaderboardModalData,
  leaderboardModalShow,
  chartData,
  platformPointCap
}



// WEBPACK FOOTER //
// ./src/store/getters.js